import {
	Component,
	ElementRef,
	HostListener,
	Input,
	OnChanges,
	SimpleChanges,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import { ReportService } from 'src/app/_services/report-service';
import { OrgService } from 'src/app/_services/org.service';
import * as c3 from 'c3';
import * as d3 from 'd3';
import { LoaderService } from 'src/app/loader/loader.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudentService } from 'src/app/_services/student.service';
import { PhaseService } from 'src/app/_services/phase.service';
import { SortingService, SortState } from 'src/app/_services/sorting.service';
import { ExportJsonService } from 'src/app/_services/export-json.service';
@Component({
	selector: 'app-number-of-students-per-challenge',
	templateUrl: './number-of-students-per-challenge.component.html',
	styleUrls: ['./number-of-students-per-challenge.component.css'],
})
export class NumberOfStudentsPerChallengeComponent implements OnChanges {
	chart: any;
	public data: any;
	public loading: boolean = false;

	public readonly CSV: boolean = true;
	public readonly XLSX: boolean = false;

	public sortState: SortState = { key: '', direction: 'asc' };
	public sortableColumns = [
		{ key: 'classroom.name', label: 'Classroom', sortable: true },
		{ key: 'lname', label: 'Last Name', sortable: true },
		{ key: 'fname', label: 'First Name', sortable: true },
		{ key: 'characteristics.grade', label: 'Grade', sortable: true },
		{ key: 'timesAssessed', label: 'Times Assessed', sortable: true },
		{ key: 'lastTestDate', label: 'Last Assessment', sortable: true },
		{ key: 'view', label: 'View', sortable: false },
	];

	public sortableColumnsAllStudents = [
		{ key: 'classroom.name', label: 'Classroom', sortable: true },
		{ key: 'lname', label: 'Last Name', sortable: true },
		{ key: 'fname', label: 'First Name', sortable: true },
		{ key: 'characteristics.grade', label: 'Grade', sortable: true },
		{ key: 'currentChallenge', label: 'Current Challenge', sortable: true },
		{ key: 'timesAssessed', label: 'Times Assessed', sortable: true },
		{ key: 'lastTestDate', label: 'Last Assessment', sortable: true },
		{ key: 'view', label: 'View', sortable: false },
	];
	isCollapsed: boolean = false;
	public columns: any[] = [];
	@ViewChild('details') detailsTemplate: TemplateRef<any>;
	@ViewChild('allstudents') allStudentsTemplate: TemplateRef<any>;
	@ViewChild('complete') completeTemplate: TemplateRef<any>;

	@Input() node: any;
	@Input() classrooms: [];

	public selectedPhases: Set<string> = new Set(['phase1', 'phase2', 'phase3', 'complete']);

	subscriptions: Subscription[] = [];
	dropdownOpen: any = false;
	tickCount: number;
	questionParticipants: any;
	allPhasesParticipants: any;
	details: any;
	questionKey: any;
	phaseKey: number | string;
	detailsTitle: string;
	color: any;
	participantsComplete: { count: number; students?: any } = { count: 0, students: {} };
	participantsCompleteStudents: any;
	participantsTable: any;
	selectedSchool: any;
	notAssessed: any;
	constructor(
		private reportService: ReportService,
		public orgService: OrgService,
		private el: ElementRef,
		public loaderService: LoaderService,
		private modalService: NgbModal,
		private StudentService: StudentService,
		public phaseService: PhaseService,
		private sortingService: SortingService,
		public exportJsonService: ExportJsonService
	) {}

	countPhasesWithTotals(): number {
		let count = 0;
		if (this.getPhaseSum(this.data?.[1011]) >= 1) count++;
		if (this.getPhaseSum(this.data?.[1012]) >= 1) count++;
		if (this.getPhaseSum(this.data?.[1013]) >= 1) count++;
		return count;
	}

	toggleCollapse(): void {
		this.isCollapsed = !this.isCollapsed;
		window.dispatchEvent(new Event('resize'));
	}

	onNodeChange(node): void {
		this.loaderService.setStudentsPerChallange(true);
		this.node = node;
		this.initializeData();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['node'] && changes['node'].currentValue) {
			this.selectedSchool = this.node;
			this.initializeData();
		}
	}

	initializeData(): void {
		this.loading = true;
		this.reportService.totalPerChallange$(this.node.id).subscribe((response) => {
			console.log('RESPONSE: ', response);
			this.notAssessed = response.participantsNotAssessed;
			console.log('notAssessed', this.notAssessed);
			this.data = response.chart;
			this.participantsComplete = response.participantsComplete ?? { count: 0, students: {} };
			this.participantsCompleteStudents = Object.values(this.participantsComplete?.students || {});
			this.questionParticipants = response.questionParticipants;
			this.allPhasesParticipants = response.allPhasesParticipants;
			this.draw();
			this.loading = false;
		});
	}

	updateSort(key: string, freshTable?: boolean): void {
		if (this.sortState.key === key && !freshTable) {
			this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : 'asc';
		} else {
			this.sortState = { key, direction: 'asc' };
		}
		this.participantsTable = this.sortingService.sort(this.participantsTable, this.sortState);
	}

	refreshComponent(): void {
		this.selectedPhases.add('phase1');
		this.selectedPhases.add('phase2');
		this.selectedPhases.add('phase3');
		this.selectedPhases.add('complete');

		this.initializeData();
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
	getPhaseSum(array: number[]): number {
		if (!array) {
			return 0;
		}
		return array.filter((num) => num !== 0).reduce((acc, num) => acc + num, 0);
	}
	getNotAssessedCount(): number {
		if (!this.notAssessed || typeof this.notAssessed !== 'object') {
			return 0;
		}
		return Object.keys(this.notAssessed).length;
	}
	getTotalStudents(): number {
		const notAssessedCount = this.getNotAssessedCount();
		const completeCount = this.participantsComplete?.count || 0;
		const allPhasesCount =
			this.allPhasesParticipants && Array.isArray(this.allPhasesParticipants)
				? this.allPhasesParticipants.length
				: this.allPhasesParticipants
				? Object.keys(this.allPhasesParticipants).length
				: 0;
		return notAssessedCount + completeCount + allPhasesCount;
	}

	getSelectedPhasesSum(): number {
		let total = 0;
		if (this.data) {
			if (this.selectedPhases.has('phase1')) {
				total += this.getPhaseSum(this.data[1011]);
			}
			if (this.selectedPhases.has('phase2')) {
				total += this.getPhaseSum(this.data[1012]);
			}
			if (this.selectedPhases.has('phase3')) {
				total += this.getPhaseSum(this.data[1013]);
			}
			if (this.selectedPhases.has('complete')) {
				total += this.participantsComplete?.count || 0;
			}
		}
		return total;
	}

	extractNumericalValues(data: any[]): number[] {
		return data.flatMap((phase) => phase.slice(1));
	}

	calculateMinMax(values: number[]): { min: number; max: number } {
		const min = Math.min(...values);
		const max = Math.max(...values);
		return { min, max };
	}

	// Function to generate dynamic tick values based on data
	generateTickValues(min: number, max: number, tickCount: number): number[] {
		if (isNaN(min) || isNaN(max)) {
			return [];
		}
		const step = (max - min) / (tickCount - 1);
		const ticks = [];

		for (let i = 0; i < tickCount; i++) {
			ticks.push(min + i * step);
		}
		console.log('ticks', ticks);
		return ticks;
	}

	draw(): void {
		if (!this.data) {
			return;
		}
		const container = this.el.nativeElement.querySelector('.chart-container');
		if (!container) {
			return;
		}
		container.innerHTML = '';
		const columns = [];
		if (
			this.selectedPhases.has('phase1') &&
			!columns.some((column) => column[0] === 'Phase I') &&
			this.getPhaseSum(this.data[1011]) >= 1
		) {
			columns.push(['Phase I', ...this.data[1011]]);
		}
		if (
			this.selectedPhases.has('phase2') &&
			!columns.some((column) => column[0] === 'Phase II') &&
			this.getPhaseSum(this.data[1012]) >= 1
		) {
			columns.push(['Phase II', ...this.data[1012]]);
		}
		if (
			this.selectedPhases.has('phase3') &&
			!columns.some((column) => column[0] === 'Phase III') &&
			this.getPhaseSum(this.data[1013]) >= 1
		) {
			columns.push(['Phase III', ...this.data[1013]]);
		}
		if (
			this.selectedPhases.has('complete') &&
			!columns.some((column) => column[0] === 'Complete') &&
			this.participantsComplete['count'] >= 1
		) {
			const completeData = new Array(25).fill(0);
			completeData[25] = this.participantsComplete['count'] || 0;
			columns.push(['Complete', ...completeData]);
		}
		console.log('columns', columns);
		this.columns = columns;

		const numericalValues = this.extractNumericalValues(columns);
		const { min, max } = this.calculateMinMax(numericalValues);
		this.tickCount = Math.min(max - min + 1, 10);
		const dynamicTickValues = this.generateTickValues(min, max, this.tickCount);

		const types = ['bar'];

		types.forEach((type, index) => {
			const chartDiv = document.createElement('div');
			chartDiv.id = `chart${index}`;
			container.appendChild(chartDiv);
			this.chart = c3.generate({
				bindto: this.el.nativeElement.querySelector(`#chart${index}`),

				data: {
					columns: this.columns,
					type: type,

					colors: {
						'Phase I': '#B65250',
						'Phase II': '#7D5FAA',
						'Phase III': '#435F90',
						Complete: '#fcc200',
					},
					names: {
						'Phase I': `Phase I`,

						'Phase II': `Phase II `,
						'Phase III': `Phase III`,
						Complete: `Complete`,
					},

					onclick: (d, element) => {
						this.loadDetails(d);
					},
				},

				legend: {
					show: false,
					item: {
						onclick: () => {},
					},
				},
				grid: {
					x: {
						show: true, // Ensure vertical grid lines are shown
						lines: Array.from({ length: 26 }, (_, i) => [
							{
								value: i + 0.5,

								position: 'end',
								class: 'grid-line',
							},
							{
								value: i - 1, // End of each bar
								class: 'grid-line2',
								position: 'end',
							},
						]).flat(),
					},
					y: {
						show: false,
					},
				},
				axis: {
					x: {
						max: 25,
						label: {
							text: 'Challenge Number',
							position: 'outer-center',
						},
						min: 0,
						grid: {
							show: true,
						},
						tick: {
							format: function (d) {
								if (d === 25) {
									return '★';
								} else {
									return `${d + 1}`;
								}
							},
							values: d3.range(0, 26, 1), // Start at 0 and end at 24
						},
					},

					y: {
						label: {
							text: 'Number of Students',
							position: 'outer-middle',
						},
						tick: {
							format: d3.format('d'),
							values: dynamicTickValues,
						},
					},
				},
				tooltip: {
					contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
						const colors = {
							'Phase I': '#B65250',
							'Phase II': '#7D5FAA',
							'Phase III': '#435F90',
						};
						let html = '';
						//console.log(d);
						if (d[0]?.id != 'Complete' && d[0]?.x != 25) {
							console.log('tooltip--', d);
							html += `<div class='tw-bg-white tw-shadow-2xl tw-rounded-lg tw-border tw-border-gray-300'>`;
							html += `<table class=' tw-p-1.5'>`;
							//html += `<tr style='border-bottom: 1px solid lightgray;'><th colspan='2' class=' tw-font-semibold tw-p-2 tw-text-center'>Challenge ${defaultTitleFormat()}</th></tr>`;
							d.forEach((data) => {
								if (data.id != 'Complete') {
									html += `<tr class='tw-bg-gray-50' style='background-color:${colors[data.id]}'>`;
									html += `<td colspan='2' class=' tw-font-bold tw-text-white tw-border-b-2'>
										<span class='tw-inline-block  tw-rounded-full tw-mr-2 tw-align-middle'
											style='background-color:${colors[data.id]}'></span>
										<span class='tw-align-middle'>${data.name}</span>
									</td>`;
									html += `</tr>`;
									html += `<tr class='tw-font-extrabold' style='border-bottom: 1px solid lightgray;'>`;
									html += `<td class='tw-p-2 '>Challenge ${defaultTitleFormat(data.index)}</td>`;
									html += `<td class='tw-text-right tw-p-2'><span class='tw-px-3 tw-py-1 tw-rounded-full tw-bg-gray-100 tw-text-gray-800'>${defaultValueFormat(
										data.value
									)}</span></td>`;
									html += `</tr>`;
								}
							});
							html += `</table></div>`;
						} else if (d[0]?.x == 25) {
							html += `<div class='tw-bg-white tw-shadow-lg tw-rounded-lg tw-border tw-border-gray-300'>`;
							html += `<table>`;
							html += `<tr class='tw-font-extrabold'>`;
							html += `<td class='tw-p-2'><span class='tw-inline-block tw-w-3 tw-h-3 tw-rounded-full tw-mr-2' style='background-color:#fcc200'></span> Complete</td>`;
							html += `<td class='tw-text-right tw-p-2'><span class='tw-px-3 tw-py-1 tw-rounded-full tw-bg-gray-100 tw-text-gray-800'>${defaultValueFormat(
								d[0].value
							)}</span></td>`;
							html += `</tr>`;
							html += `</table></div>`;
						}

						return html;
					},
				},
				bar: {
					width: {
						ratio: 0.7,
					},
				},
				onrendered: () => {},
			});
		});
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void {
		if (this.chart) {
			this.chart.resize();
		}
	}

	dismissPhase(phase: string): void {
		this.selectedPhases.delete(phase);
		this.removePhaseFromChart(phase);
	}
	public showWindow(n) {
		this.modalService.open(n);
	}
	onPhaseClick(phase: string): void {
		if (this.selectedPhases.has(phase)) {
			console.log('phase', phase);
			this.selectedPhases.delete(phase);
			this.removePhaseFromChart(phase);
		} else {
			this.selectedPhases.add(phase);
			this.addPhaseToChart(phase);
		}
	}

	addPhaseToChart(phase: string): void {
		let phaseName: string;
		let phaseData: number[];

		switch (phase) {
			case 'complete':
				phaseName = 'Complete';
				phaseData = new Array(25).fill(0);
				phaseData[25] = this.participantsComplete['count'] || 0;

				break;
			case 'phase1':
				phaseName = 'Phase I';
				phaseData = this.data[1011];
				break;
			case 'phase2':
				phaseName = 'Phase II';
				phaseData = this.data[1012];
				break;
			case 'phase3':
				phaseName = 'Phase III';
				phaseData = this.data[1013];
				break;
			default:
				return;
		}

		// Check if the phase already exists in the columns array
		const phaseExists = this.columns.some((column) => column[0] === phaseName);

		if (!phaseExists) {
			this.columns.push([phaseName, ...phaseData]);
			console.log('columns', this.columns);
			this.columns.sort((a, b) => {
				const order = ['Phase I', 'Phase II', 'Phase III'];
				return order.indexOf(a[0]) - order.indexOf(b[0]);
			});

			console.log('Updated columns:', this.columns);
			this.chart.load({
				columns: this.columns,
			});
		}
	}

	removePhaseFromChart(phase: string): void {
		let phaseName: string;
		switch (phase) {
			case 'complete':
				phaseName = 'Complete';
				break;
			case 'phase1':
				phaseName = 'Phase I';
				break;
			case 'phase2':
				phaseName = 'Phase II';
				break;
			case 'phase3':
				phaseName = 'Phase III';
				break;
			default:
				return;
		}

		// Unload the phase from the chart
		this.chart.unload({
			ids: [phaseName],
		});
		this.columns = this.columns.filter((column) => column[0] !== phaseName);
		console.log('columnsssss', this.columns);
	}

	goToChildPage(participant): void {
		localStorage.setItem('selectedStudent', JSON.stringify(participant));
		localStorage.setItem('selectedClassroom', JSON.stringify(participant.classroom));
		//localStorage.setItem('selectedPhase', JSON.stringify(participant.completedPhases));

		console.log('goToChildPage', participant);
		window.open('/dashboard', '_blank');
		//this.modalService.dismissAll();
	}
	loadDetails(d: any): void {
		console.log(d);
		switch (d.id) {
			case 'Complete':
				this.color = '#d8ab19';
				this.detailsTitle = 'Challenges Complete';
				break;
			case 'Phase I':
				this.phaseKey = 1011;
				this.color = '#B65250';
				this.detailsTitle = 'Phase I';
				break;
			case 'Phase II':
				this.phaseKey = 1012;
				this.color = '#7D5FAA';
				this.detailsTitle = 'Phase II';
				break;
			case 'Phase III':
				this.phaseKey = 1013;
				this.color = '#435F90';
				this.detailsTitle = 'Phase III';
				break;
			default:
				this.phaseKey = 1011;
				this.color = '#B65250';
				this.detailsTitle = 'Phase I';
				return;
		}
		if (d.id != 'Complete') {
			this.questionKey = d.index + 1;
			this.participantsTable = this.questionParticipants[this.phaseKey][this.questionKey];
		} else {
			console.log('detailsTitle', this.detailsTitle);
			this.participantsTable = this.participantsCompleteStudents;
		}
		this.updateSort('classroom.name', true);
		this.modalService.open(this.detailsTemplate, { size: 'xl', scrollable: true });
	}

	loadAllStudents() {
		this.phaseKey = 'All';
		this.color = '#243670';
		this.detailsTitle = 'All Students';
		this.questionKey = null;
		this.participantsTable = this.allPhasesParticipants;
		this.updateSort('classroom.name');
		this.modalService.open(this.allStudentsTemplate, { size: 'xl', scrollable: true });
	}

	fetchChallengeLabel(challengeNumber: number) {
		//Just feels cleaner than binding in the template
		let returnLabel: string;
		if (challengeNumber == 0) {
			returnLabel = 'No scores';
		} else if (challengeNumber == 26) {
			returnLabel = 'Complete';
		} else {
			returnLabel = 'Challenge ' + challengeNumber;
		}

		return returnLabel;
	}

	fetchPhaseNumeral(phaseNumber: number) {
		switch (phaseNumber) {
			case 1:
				return 'I';
			case 2:
				return 'II';
			case 3:
				return 'III';
			default:
				return '?';
		}
	}

	getPhaseLabel(phaseNumber: number): string {
		switch (phaseNumber) {
			case 1:
				return 'I';
			case 2:
				return 'II';
			case 3:
				return 'III';
			default:
				return 'C';
		}
	}

	getChallengeProgress(challengeNumber: number): number {
		if (!challengeNumber || challengeNumber === 0) {
			return 100; // Complete - show 100% progress with gold
		}
		if (challengeNumber === 26) {
			return 100; // Complete
		}
		// Calculate progress as percentage of 25 challenges
		return Math.min(100, (challengeNumber / 25) * 100);
	}

	getProgressBarClass(currentChallenge: any): string {
		if (currentChallenge?.challenge === 0) {
			return 'tw-bg-[#fcc200] tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-transition-all tw-duration-300';
		}
		const divisionClass = currentChallenge?.division ? `color-${currentChallenge.division}` : '';
		return `${divisionClass} tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-transition-all tw-duration-300 tw-rounded-r-sm`.trim();
	}

	getSegmentsArray(currentChallenge: any): Array<{ completed: boolean; current: boolean }> {
		const segments = [];
		const questionNumber = currentChallenge?.challenge === 0 ? 25 : currentChallenge?.questionNumber || 0;

		for (let i = 1; i <= 25; i++) {
			segments.push({
				completed: i < questionNumber,
				current: i === questionNumber,
			});
		}

		return segments;
	}
}
